import { render, staticRenderFns } from "./CustomerAssociationManager.vue?vue&type=template&id=583ba202"
import script from "./CustomerAssociationManager.vue?vue&type=script&lang=js"
export * from "./CustomerAssociationManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports